import React from 'react';

const ReorderIcon = () => {
  return <svg className="reorder" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><g transform="translate(-238.5 -847.786)"><path d="M238.5,861.848h25v3.123h-25Zm0-6.25h25v3.123h-25Zm13.019,17.188,4.689-4.688h-9.373l3.321,3.324Zm0-25-4.685,4.685h9.373Z" transform="translate(0 0)" fill="#909dbf"/></g></svg>
}

export default ReorderIcon;


// WEBPACK FOOTER //
// ./src/components/counseling-session/order-of-importance/ReorderIcon.js